import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'

import { useValueContext, analyticsContext } from 'contexts'
import { IEvent } from 'types'
import { ArrowRightIcon, EventIcon, Spinner } from 'components'
import { formatDate, formatDuration } from 'utils'

import { eventTypes } from '../../constants'

import './styles.scss'
import React from 'react'

const dateFormat = 'HH:mm'

export const EventsList = observer(() => {
  const navigate = useNavigate()
  const { store } = useValueContext()
  const { loadEvents, baby, groupedEvents, loadingMore } = store

  useEffect(() => {
    if (baby?.id) {
      loadEvents()
    }
  }, [baby?.id, loadEvents])

  return (
    <div className="events-list">
      <Spinner variant="sm" className="events-list-spinner" open={loadingMore} />
      {Object.keys(groupedEvents).map((label: string) => {
        const events = groupedEvents[label]
        const splitByColon = label.split(':')

        const outputLabelJsx =
          splitByColon.length > 1 ? (
            <>
              <span>{splitByColon[0]}:</span> {splitByColon[1]}
            </>
          ) : (
            label
          )

        return (
          <React.Fragment key={label}>
            <div className="date">{outputLabelJsx}</div>
            {events.map((event: IEvent) => {
              const { id, eventTypeCode, startTime, endTime } = event
              const eventType = eventTypes.find(({ type }) => type === eventTypeCode)

              const duration = formatDuration(startTime, endTime)

              const onClick = () => {
                analyticsContext.trackEvent('event_edit_clicked', { event_name: eventTypeCode })
                navigate(`/event/${id}`, { state: { event: { ...event } } })
              }

              return (
                <div className="events-list-item" key={id} onClick={onClick}>
                  {eventType && (
                    <EventIcon
                      className="event-icon"
                      iconName={eventType.icon}
                      iconProps={{ width: 22, height: 22 }}
                      width={39}
                      height={39}
                    />
                  )}
                  <div>
                    {eventType && (
                      <div className="title" style={{ color: eventType.color }}>
                        {eventType?.title}
                      </div>
                    )}
                    <div className="time-wrapper">
                      <div className="time">
                        {formatDate(startTime, dateFormat)}{' '}
                        {endTime && <>- {formatDate(endTime, dateFormat)}</>}
                      </div>
                      {duration && <div className="duration">{duration}</div>}
                    </div>
                  </div>
                  <ArrowRightIcon className="event-arrow" fill="#c9c9c9" />
                </div>
              )
            })}
          </React.Fragment>
        )
      })}
    </div>
  )
})
